exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".google-btn[data-v-49620ea6] {\n  width: 100%;\n  height: 50px;\n}\n@media (max-width: 768px) {\n.google-btn[data-v-49620ea6] {\n      height: 45px;\n}\n}\n", ""]);

// exports
